import { createApi} from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const leadApi = createApi({
  reducerPath: "leadApi",
  
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}Lead/`),

  endpoints: (builder) => ({
    getAllLeads: builder.query({
      query: () => ({
        url: "GetLeads",
        method: "GET",
      }),
    }),

    getLeadById: builder.query({
      query: (id) => ({
        url: `GetLeadById?leadId=${id}`,
        method: "GET",
      }),
    }),

    getAllLeadStatus: builder.query({
      query: () => ({
        url: "GetLeadStatus",
        method: "GET",
      }),
    }),

    getLeadsFollowUp: builder.query({
      query: () => ({
        url: "GetLeadFollowUp",
        method: "GET",
      }),
    }),

    getReplyComments: builder.query({
      query: () => ({
        url: "GetReplyComments",
        method: "GET",
      }),
    }),

    getLeadFollowUpByLeadId: builder.query({
      query: (id) => ({
        url: `GetLeadFollowUpByLeadId?leadId=${id}`,
        method: "GET",
      }),
    }),

    uploadLead: builder.mutation({
      query: (body) => {
        return {
          url: "UploadLeads",
          method: "POST",
          body,
        };
      },
    }),

    addLead: builder.mutation({
      query: (body) => {
        return {
          url: "AddLead",
          method: "POST",
          body,
        };
      },
    }),

    addFollowUp: builder.mutation({
      query: (body) => {
        return {
          url: "AddFollowUpComment",
          method: "POST",
          body,
        };
      },
    }),

    addFinalOutcome: builder.mutation({
      query: (body) => {
        return {
          url: "AddFinalOutcome",
          method: "POST",
          body,
        };
      },
    }),

    getLeadsOutcome: builder.query({
      query: () => ({
        url: "GetLeadOutcomes",
        method: "GET",
      }),
    }),

    replyFollowUp: builder.mutation({
      query: (body) => {
        return {
          url: "ReplyFollowUpComment",
          method: "POST",
          body,
        };
      },
    }),

    updateLead: builder.mutation({
      query: (body) => {
        return {
          url: "UpdateLead",
          method: "PUT",
          body,
        };
      },
    }),
    deleteLead: builder.mutation({
      query: (id) => ({
        url: `DeleteLead?leadId=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllLeadsQuery,
  useGetAllLeadStatusQuery,
  useGetLeadByIdQuery,
  useGetLeadsOutcomeQuery,
  useGetLeadsFollowUpQuery,
  useGetReplyCommentsQuery,
  useGetLeadFollowUpByLeadIdQuery,
  useAddLeadMutation,
  useAddFinalOutcomeMutation,
  useReplyFollowUpMutation,
  useUploadLeadMutation,
  useUpdateLeadMutation,
  useDeleteLeadMutation,
  useAddFollowUpMutation,
} = leadApi;

export default leadApi.reducer;
